import { useSelector } from 'react-redux'

// Types
import { State } from 'types'

export const useIsAuthenticated = (): boolean => {
  return useSelector<State, boolean>(state => state.auth.isAuthenticated)
}
